module.exports = __webpack_public_path__ + "static/features-3.a471c508.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/features-3.png
// module id = 234
// module chunks = 0